import React from 'react';
import Loader from './Loader';

/**
 * @param {Object} props
 * @param {boolean} props.loading
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 * @param {React.ReactNode} props.skeleton
 */
export default function Loading({
  loading = true,
  className = '',
  children = null,
  skeleton = null
}) {
  if (!loading) {
    return children;
  }

  return skeleton || <Loader customClass={className} />;
}
